import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DbService {

  constructor(private http: HttpClient) {}

  // MySql Provide Code ...........................................
  
  private apiUrl = environment.apiUrl; // Backend URL


  // SSLCommerz Endpoints..........................................
  getSSLCheckOutUrl(data: any): Observable<any> {
    return this.http.post(this.apiUrl+"/sslcz_checkout", data);
  }

  getSSLCZPaymentStatus(tran_id: string): Observable<any> {
    return this.http.get(this.apiUrl+"/sslcz_payment_status/"+tran_id);
  }

  validateSSLCZPayment(data: any): Observable<any> {
    return this.http.post(this.apiUrl+"/sslcz_validate", data);
  }

  // Kiko Endpoints...............................................
  getAllUsers() : Observable<any> {
    return this.http.get(this.apiUrl+"/users");
  }

  getUser(udid : string): Observable<any> {
    return this.http.get(this.apiUrl+"/get_user/"+udid);
  }

  addUser(data: any): Observable<any> { // data = { udid, region }
    return this.http.post(this.apiUrl+"/add_user", data);
  }

  addUserDuration(data : any): Observable<any> { // data = { udid, duration }
    return this.http.post(this.apiUrl+"/add_user_duration", data);
  }

  forceUpdateUserDuration(data : any): Observable<any> { // data = { udid, duration }
    return this.http.post(this.apiUrl+"/force_update_user_duration", data);
  }

  updateUserBlockServer(data : any): Observable<any> { // data = { udid, server_id }
    return this.http.post(this.apiUrl+"/update_user_block_server", data);
  }

  updateUserBlockDomain(data : any): Observable<any> { // data = { udid, domain_id }
    return this.http.post(this.apiUrl+"/update_user_block_domain", data);
  }

  getAutoVPNServer(udid : string): Observable<any> {
    return this.http.get(this.apiUrl+"/auto_server/"+udid);
  }

  getAllResellers() : Observable<any> {
    return this.http.get(this.apiUrl+"/resellers");
  }

  getResellerByEmail(email : string): Observable<any> {
    return this.http.get(this.apiUrl+"/get_reseller/"+email);
  }

  addReseller(data: any): Observable<any> { // data = { email, region }
    return this.http.post(this.apiUrl+"/add_reseller", data);
  }

  updateResellerBalance(data : any): Observable<any> { // data = { email, balance }
    return this.http.post(this.apiUrl+"/update_reseller_balance", data);
  }

  getAllCoupons() : Observable<any> {
    return this.http.get(this.apiUrl+"/coupons");
  }

  getAllCouponsByResellerID(reseller_id : string) : Observable<any> {
    return this.http.get(this.apiUrl+"/coupons_by_reseller/"+reseller_id);
  }

  getAllCouponsByStatus(status : string) : Observable<any> {
    return this.http.get(this.apiUrl+"/coupons_by_status/"+status);
  }

  getCouponByCode(code : string) : Observable<any> {
    return this.http.get(this.apiUrl+"/coupons_by_code/"+code);
  }

  addResellerCoupon(data: any): Observable<any> { // data = {values : [{ reseller_id, code, duration, amount, server_id }]}
    return this.http.post(this.apiUrl+"/add_coupon_reseller", data);
  }

  addAffiliateCoupon(data: any): Observable<any> { // data = { reseller_id, code, type, duration, amount, discount, server_id }
    return this.http.post(this.apiUrl+"/add_coupon_affiliate", data);
  }

  applyCoupon(data: any): Observable<any> { // data = { udid, code }
    return this.http.post(this.apiUrl+"/update_coupon", data);
  }

  getAllPayments() : Observable<any> {
    return this.http.get(this.apiUrl+"/payments");
  }

  getAllPaymentsForReseller(reseller_id : string) : Observable<any> {
    return this.http.get(this.apiUrl+"/payments_by_reseller/"+reseller_id);
  }

  getAllPaymentsForAffiliate(code : string) : Observable<any> {
    return this.http.get(this.apiUrl+"/payments_by_affiliate/"+code);
  }

  getAllPaymentsForUser(user_id : string) : Observable<any> {
    return this.http.get(this.apiUrl+"/payments_by_user/"+user_id);
  }

  addPayment(data: any): Observable<any> { // data = { type, invoice_id, user_id, user_type, status, duration, amount, discount, gateway }
    return this.http.post(this.apiUrl+"/add_payment", data);
  }

  getResellerPricing(): Observable<any> {
    return this.http.get(this.apiUrl+"/pricing_reseller");
  }

  getGateways(): Observable<any> {
    return this.http.get(this.apiUrl+"/gateway");
  }

  getInfoData(): Observable<any> {
    return this.http.get(this.apiUrl+"/info");
  }

  updateAndroidDownload(data: any): Observable<any> { // data = { count }
    return this.http.post(this.apiUrl+"/update_android_download", data);
  }  

  updateiOSDownload(data: any): Observable<any> { // data = { count }
    return this.http.post(this.apiUrl+"/update_ios_download", data);
  }  

  updateWinDownload(data: any): Observable<any> { // data = { count }
    return this.http.post(this.apiUrl+"/update_win_download", data);
  }  

  updateMacDownload(data: any): Observable<any> { // data = { count }
    return this.http.post(this.apiUrl+"/update_mac_download", data);
  }  

  getBlogsData(): Observable<any> {
    return this.http.get(this.apiUrl+"/blogs");
  }

  getFeedbackData(): Observable<any> {
    return this.http.get(this.apiUrl+"/feedbacks");
  }

}